import Chip from '@material-ui/core/Chip';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import QuantityControlLite from 'components-v2/mocules/QuantityControlLite';
import QuantityControlViewed from 'components-v2/mocules/QuantityControlViewed';
import { VARIANT_LIST } from 'components-v2/ui/ConsultSpecialProductBtn';
import { QUICKORDER_CROSS_SELL_ICON, QUICKORDER_SUGGEST_ICON } from 'constants/Images';
import { getPathProductBySlug } from 'constants/Paths';
import { SVGPrice } from 'constants/SVG';
import Image from 'next/image';
import Link from 'next/link';
import { CrossSellItem } from 'types/product';
import { ImageFallbackProductImage } from 'utils/ImageFallback';
import styles from './styles.module.css';

interface Props {
  items: CrossSellItem[];
  /**
   * Cùng nghĩa với SubstituteSKUCard: 'quickOrder' đi qua CartContext (ĐHN),
   * 'lite' (mặc định) đi qua store zustand `useCart` (giỏ hàng, PDP).
   */
  quantityVariant?: 'lite' | 'quickOrder';
  className?: string;
}

// BV-2271: block "Sản phẩm hay mua kèm" — clone bố cục SubstituteSKUCard, bỏ tracking/tour/Xem thêm
// (tracking làm ở BV-2273). BFF đã lọc + sort sẵn, FE chỉ render theo thứ tự nhận được.
const CrossSellSKUCard = ({ items, quantityVariant = 'lite', className }: Props) => (
  <div className={clsx(styles.card, className)}>
    <Box className={styles.suggestCard}>
      <Image src={QUICKORDER_SUGGEST_ICON} width={24} height={24} loading="lazy" alt="suggest icon" />
      Gợi ý
    </Box>
    <Box className={clsx(styles.listCard, { [styles.multi]: items.length > 1 })}>
      {items.map((item) => {
        const { productId, productName, imageUrl, volume, price, originPrice = 0, discountPercent = 0, limitMessage = '', sellerName, sellerUrl } = item;
        const linkHref = getPathProductBySlug(item.slug);
        // QuantityControlViewed / useCartQuickOrder đọc id / name / currentPrice / isDeal — map như SubstituteSKUCard
        const quickOrderProduct = { ...item, id: productId, name: productName, currentPrice: price, isDeal: item.type === 'DEAL' };

        return (
          <Box key={item.skuCode} className={styles.itemCard}>
            <span className={styles.tagCard}>
              <Image src={QUICKORDER_CROSS_SELL_ICON} width={14} height={14} loading="lazy" alt="cross sell icon" />
              Sản phẩm hay mua kèm
            </span>
            <Box className={styles.imageCard}>
              <Link href={linkHref} prefetch={false}>
                <ImageFallbackProductImage
                  src={imageUrl}
                  alt={productName}
                  width={88}
                  height={88}
                  quality={100}
                  title={productName}
                  loading="lazy"
                  objectFit="contain"
                  size="thumbnail"
                />
              </Link>
            </Box>
            <Box className={styles.contentCard}>
              <Link href={linkHref} prefetch={false} passHref>
                <a className={styles.productName}>{productName}</a>
              </Link>
              <span className={styles.cardSubTitle}>{volume}</span>
              {sellerName && (
                <a className={styles.sellerName} href={sellerUrl} target="_blank" rel="noreferrer">
                  {sellerName}
                </a>
              )}
            </Box>
            {/* Cột giá: hàng trên % giảm + giá gốc gạch ngang, hàng dưới giá đã giảm (như SPTT) */}
            <Box className={styles.priceCard}>
              {discountPercent > 0 && originPrice > 0 && (
                <Box className={styles.priceRow}>
                  <Chip className={styles.cardChip} label={`-${discountPercent}%`} size="small" />
                  <SVGPrice displayPriceFormated={originPrice} fillPath="#333" size="xs" line />
                </Box>
              )}
              <Box className={styles.priceRow}>
                <SVGPrice displayPriceFormated={price} size="lg" textRight />
              </Box>
            </Box>
            <Box className={styles.actionCard}>
              {!!limitMessage && <span className={styles.limitMessage}>{limitMessage}</span>}
              {quantityVariant === 'quickOrder' ? (
                <QuantityControlViewed className={styles.quantityControlQuickOrder} product={quickOrderProduct} newCard />
              ) : (
                <QuantityControlLite className={styles.quantityControlCart} product={item} newCard consultVariant={VARIANT_LIST.LIST_HORIZONTAL} />
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  </div>
);

export default CrossSellSKUCard;
